module.exports = __webpack_public_path__ + "img/MATEMaTICA.47d79edb.png";